import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/utils/vant';
import '@/assets/css/main.less' // global css
import '@/assets/css/transition.css';
import { ENV_CONFIG } from '@/config';

import '@/utils/Filters/index';

import '@/utils/Directive/index';

import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.css';
Vue.prototype.$swiper = Swiper;
import Layer from '@/utils/Layer/index';
import '@/utils/Layer/style.css';
Vue.prototype.$layer = Layer;

import filterXSS from 'xss'
Vue.prototype.$filterXSS = (params) => filterXSS(params)

import VueLazyload from 'vue-lazyload';
const errorImg = require('@/assets/img/error.png');
const loadingImg = require('@/assets/img/loading.png');
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorImg,
  loading: loadingImg,
  attempt: 1
});

const Bus = {
  install: () => {
    Vue.prototype.$Bus = new Vue();
  }
};
Vue.use(Bus);

if (!ENV_CONFIG.IS_PRIVATE) {
  require('@/utils/arms');
}
const Cookie = require('js-cookie');
Vue.prototype.$cookie = Cookie;
require('@/utils/deviceId');
const PhotoSwipe = require('vue-photoswipe.js');
require('vue-photoswipe.js/dist/static/css/photoswipe.css');
Vue.use(PhotoSwipe.default, {
  wechat: window.wx,
  pswpOptions: {
    showShare: false,
    showClose: true,
    showFullscreen: false,
    showZoom: false
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
